import { jsx as n } from "react/jsx-runtime";
import { Input as r, InputNumber as a } from "antd";
import { memo as v, useRef as c } from "react";
import { useEventResolver as l } from "@biron-data/react-contexts";
const g = v((e) => {
  const t = c(e.value), u = l();
  switch (e.type) {
    case "numeric":
      return /* @__PURE__ */ n(a, { ...e, onBlur: () => {
        e.gaevent && t.current !== e.value && (t.current = e.value, u.capture(e.gaevent));
      } });
    default:
      return /* @__PURE__ */ n(r, { ...e, onBlur: () => {
        e.gaevent && t.current !== e.value && (t.current = e.value, u.capture(e.gaevent));
      } });
  }
});
export {
  g as default
};
//# sourceMappingURL=GAInput.js.map
